
export default function Footer() {
  return (
    <footer className="bg-gray-100 border-t">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* サイトタイトルと概要 */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/e53389d15fd8e697adec40b473f711b4.jpg" 
                className="h-10 w-10 object-contain" 
                alt="ジコゼロ" 
              />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              ジコゼロは、人事評価やタレントマネジメント、人材育成など、人事に関わる方にお役立ていただける情報を発信するメディアです。最新のHRトレンドや実践的なノウハウをわかりやすく解説しています。
            </p>
          </div>
          
          {/* メニュー */}
          <div>
            <h4 className="text-md font-semibold text-gray-900 mb-4">メニュー</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">ホーム</a></li>
              <li><a href="/blog" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">ブログ</a></li>
              <li><a href="/document" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">資料ダウンロード</a></li>
              <li><a href="/contact" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">お問い合わせ</a></li>
            </ul>
          </div>
          
          {/* カテゴリー */}
          <div>
            <h4 className="text-md font-semibold text-gray-900 mb-4">カテゴリー</h4>
            <ul className="space-y-2">
              <li><a href="/blog?category=配信機材" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">配信機材</a></li>
              <li><a href="/blog?category=配信ソフト" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">配信ソフト</a></li>
              <li><a href="/blog?category=トラブル対処" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">トラブル対処</a></li>
              <li><a href="/blog?category=配信テクニック" className="text-gray-600 text-sm hover:text-cyan-500 transition-colors cursor-pointer">配信テクニック</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-4 mb-4 md:mb-0">
            <a href="/" className="text-gray-600 hover:text-cyan-500 transition-colors cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="fas fa-home"></i>
              </div>
            </a>
          </div>
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-gray-500 text-sm">© 2026 ジコゼロ All rights reserved.</p>
            <a href="https://readdy.ai/?ref=logo" className="text-gray-500 text-sm hover:text-cyan-500 transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
